import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export function Agb() {
  return (
    <div className="min-h-screen bg-white text-ink-900">
      <header className="border-b border-border">
        <div className="container flex items-center justify-between py-4">
          <Link to="/" className="flex items-center gap-2">
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-xl bg-brand-gradient">
              <Heart className="h-4 w-4 text-white" fill="currentColor" />
            </span>
            <span className="text-lg font-bold tracking-tight">Parble</span>
          </Link>
          <Link to="/" className="text-sm font-semibold text-ink-500 hover:text-ink-900">
            Zurück zur Startseite
          </Link>
        </div>
      </header>

      <main className="container max-w-3xl py-12 prose prose-neutral">
        <div className="not-prose mb-10">
          <h1 className="text-4xl font-bold tracking-tight">
            Allgemeine Geschäftsbedingungen
          </h1>
          <p className="mt-2 text-ink-500">
            Diese AGB sind ein Template-Entwurf. Vor Launch durch einen Fachanwalt
            für IT-Recht zu prüfen.
          </p>
        </div>

        <h2>1. Geltungsbereich</h2>
        <p>
          Diese AGB regeln das Vertragsverhältnis zwischen dir (im Folgenden
          „Nutzer") und der Parble (im Folgenden „Anbieter") hinsichtlich der
          Nutzung der Online-Plattform parble.app.
        </p>

        <h2>2. Vertragsgegenstand</h2>
        <p>
          Parble ist eine Dating-Plattform, die Menschen über psychologisches
          Werte-Matching zusammenbringt. Der Anbieter vermittelt keine
          persönlichen Kontakte und übernimmt keine Gewähr für das Zustandekommen
          von Beziehungen.
        </p>

        <h2>3. Registrierung und Mindestalter</h2>
        <p>
          Die Nutzung ist Personen ab 18 Jahren vorbehalten. Mit der Registrierung
          versicherst du, volljährig zu sein. Falsche Angaben führen zur
          sofortigen Kündigung.
        </p>

        <h2>4. Kostenlose Testphase und Abo</h2>
        <p>
          Nach der Registrierung erhältst du einen kostenlosen Zeitraum von 30
          Tagen. Danach beträgt die Monatsgebühr 5,00 € (inkl. 19% USt.). Das Abo
          ist jederzeit zum Ende des Abrechnungszeitraums kündbar. Der Preis ist
          für alle Nutzer identisch, unabhängig vom Geschlecht.
        </p>

        <h2>5. Pflichten des Nutzers</h2>
        <ul>
          <li>Wahrheitsgemäße Angaben zur eigenen Person.</li>
          <li>
            Keine Beleidigungen, keine Belästigung, keine sexuellen Inhalte ohne
            Einverständnis.
          </li>
          <li>Keine Fake-Profile oder Mehrfachkonten.</li>
          <li>Kein Werben für Dienstleistungen oder Produkte.</li>
        </ul>

        <h2>6. Kündigung</h2>
        <p>
          Du kannst dein Abo über das Stripe-Kundenportal jederzeit kündigen.
          Dein Konto kannst du in den Einstellungen unwiderruflich löschen.
        </p>

        <h2>7. Haftung</h2>
        <p>
          Der Anbieter haftet nur für Schäden, die auf Vorsatz oder grober
          Fahrlässigkeit beruhen. Keine Haftung für durch andere Nutzer verursachte
          Schäden.
        </p>

        <h2>8. Streitbeilegung</h2>
        <p>
          Die Europäische Kommission stellt eine Plattform zur
          Online-Streitbeilegung bereit:{" "}
          <a href="https://ec.europa.eu/consumers/odr">
            ec.europa.eu/consumers/odr
          </a>
          . Der Anbieter ist nicht verpflichtet, an Streitbeilegungsverfahren
          teilzunehmen.
        </p>

        <h2>9. Schlussbestimmungen</h2>
        <p>
          Es gilt deutsches Recht. Gerichtsstand ist, soweit zulässig, der Sitz
          des Anbieters.
        </p>

        <p className="mt-10 text-sm text-ink-500">
          Stand: Entwurfs-Vorlage. Rechtsverbindliche Fassung folgt nach
          Anwalts-Review.
        </p>
      </main>
    </div>
  );
}
